import { useRef } from "react";
import { nw } from "@/components/landing/landing-data";
import { useOnScreen, usePageVisible } from "@/components/landing/landing-motion";

/** V6: each word eases down to 30% and back on a 7s loop, one after another. */
const WORD_DELAYS = ["0s", "0.8s", "3.5s", "4.3s"];

export function ManifestoSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const onScreen = useOnScreen(sectionRef, 0.1);
  const pageVisible = usePageVisible();
  const word = (i: number) => ({ animationDelay: WORD_DELAYS[i] });

  return (
    <section
      ref={sectionRef}
      aria-labelledby="lp-manifesto-title"
      data-paused={!onScreen || !pageVisible}
      className="relative overflow-hidden px-4 pb-24 pt-24 sm:px-8 md:pb-[120px] md:pt-[150px]"
    >
      <div
        aria-hidden
        className="lp-wash left-1/2 top-[90px] h-[380px] w-[700px] -translate-x-1/2"
        style={{ background: "radial-gradient(closest-side, rgb(238 232 248 / 0.8), rgb(238 232 248 / 0))" }}
      />
      <div className="relative mx-auto max-w-[1200px] text-center">
        <h2
          id="lp-manifesto-title"
          className="m-0 text-[clamp(2.5rem,7vw,5.25rem)] font-semibold leading-[1.02] tracking-[-0.05em] text-(--lp-ink)"
        >
          <span className="lp-breathe" style={word(0)}>
            Motivation
          </span>{" "}
          <span className="lp-breathe" style={word(1)}>
            fades.
          </span>
          <br />
          <span className="lp-breathe lp-accent" style={word(2)}>
            Momentum
          </span>{" "}
          <span className="lp-breathe" style={word(3)}>
            compounds.
          </span>
        </h2>
        <p className="mx-auto mt-7 max-w-[620px] text-lg text-(--lp-muted) sm:text-xl">
          {nw("For growth-minded people who want to act on what they learn.")}
        </p>
      </div>
    </section>
  );
}
